import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, centred, doc, hairline, ornament } from "./kit";
import type { LabelTemplate } from "./types";

// Wedding: the couple's names in script beneath a small gold wreath.
function wine(): CanvasData {
  const b = "wine";
  return doc(b, INK["warm-white"], [
    ornament("closed-wreath", INK.gold, { width: 14, at: [45, 26], anchor: [100, 100] }),
    centred(b, { text: "Anna & James", font: "great-vibes", size: 9, color: INK.gold, baseline: 48 }),
    centred(b, { text: "together with their families", font: "cormorant", italic: true, size: 2.6, color: INK.charcoal, baseline: 56.5, tracking: 0.03 }),
    hairline(INK.gold, 45, 61.5, 24),
    centred(b, { text: "12 · 09 · 2026", font: "cinzel", size: 3, color: INK.charcoal, baseline: 69, tracking: 0.15 }),
    centred(b, { text: "Cellar-bottled for the celebration", font: "montserrat", size: 1.7, color: INK.charcoal, baseline: 88, tracking: 0.08 }),
  ]);
}

export const weddingScript: LabelTemplate = {
  key: "wedding-script",
  name: "Wedding",
  occasion: "wedding",
  style: "Script and laurels",
  description: "Your names in script beneath a small gold wreath.",
  hasImageSlot: false,
  build: (bottle: BottleType) => (bottle === "wine" ? wine() : rebottle(wine(), bottle)),
};
